import { render, staticRenderFns } from "./skills-card-form-goto.vue?vue&type=template&id=7886ca44&"
import script from "./skills-card-form-goto.vue?vue&type=script&lang=js&"
export * from "./skills-card-form-goto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports